import React, { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "animate.css";

const GeneralDentistryProcess = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="d-flex justify-content-center align-items-center"
      style={{ backgroundColor: "#FFFBF1", minHeight: "95vh" }}
    >
      <div className="container">
        <div className="text-center mt-5">
          <h2
            className={`animate__animated fs-40 ${
              isVisible ? "animate__fadeIn" : "animate__fadeOut"
            }`}
          >
            Regent Dental's Approach <br></br> to Your Brighter Smile
          </h2>
          <p
            className={`w-75 mx-auto animate__animated ${
              isVisible ? "animate__fadeIn" : "animate__fadeOut"
            } animate__delay-1s`}
          >
            Your comfort and stunning results are our priority. We use 3D
            scanners and high-quality whitening gels to provide you with a safe
            and pleasant experience to get your whiter smile.
          </p>
        </div>

        <div className="p-4">
          <div className="row justify-content-center">
            {[
              {
                number: 1,
                title: "Consultation",
                description:
                  "Every whitening journey begins with a thorough assessment of your dental health and discussion of your aesthetic goals.",
              },
              {
                number: 2,
                title: "Customisation",
                description:
                  "A scan of your teeth is taken to create custom whitening trays that fit perfectly, ensuring even coverage and comfort.",
              },
              {
                number: 3,
                title: "Whitening",
                description:
                  "Depending on your needs and preferences, whitening syringes will be prescribed for at-home whitening.",
              },
              {
                number: 4,
                title: "Final Touches",
                description:
                  "Post-whitening, we will provide you with expert advice to maintain your new, brighter smile and ensure long-lasting results.",
              },
            ].map((service, index) => (
              <div className="col-md-4 mb-4" key={index}>
                <div
                  className={`card card-body border-0 rounded-4 animate__animated ${
                    isVisible ? "animate__fadeInUp" : "animate__fadeOut"
                  }`}
                >
                  <div
                    style={{ height: "50px", width: "50px" }}
                    className="bg-golden rounded-3 text-light fw-700 fs-34 text-center mb-3"
                  >
                    {service.number}
                  </div>
                  <div className="fs-18 fw-600">{service.title}</div>
                  <p className="fs-14">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GeneralDentistryProcess;
